var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeAgreement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.36,27.64c-2.1,0-3.79-1.7-3.79-3.79s1.7-3.8,3.79-3.8h39.4c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79H22.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.36,41.12c-2.1,0-3.79-1.7-3.79-3.79s1.7-3.8,3.79-3.8h13.4c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79h-13.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.36,53.79c-2.1,0-3.79-1.7-3.79-3.79s1.7-3.8,3.79-3.8h3.4c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79h-3.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.36,80.5c-2.1,0-3.79-1.7-3.79-3.79s1.7-3.8,3.79-3.8h6.83c2.1,0,3.8,1.7,3.8,3.8s-1.7,3.79-3.8,3.79h-6.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,23.84c0-2.1,1.7-3.79,3.79-3.79s3.8,1.7,3.8,3.79v52.86c0,2.1-1.7,3.8-3.8,3.8s-3.79-1.7-3.79-3.8V23.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.96,23.84c0-2.1,1.7-3.79,3.79-3.79s3.8,1.7,3.8,3.79v4.85c0,2.1-1.7,3.8-3.8,3.8s-3.79-1.7-3.79-3.8v-4.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.15,38.13c4.4-4.4,11.7-4.4,16.1,0,4.4,4.4,4.4,11.7,0,16.1l-21,21c-1.6,1.6-3.6,2.7-5.8,3.1l-11.2,2.2c-1.2.2-2.5-.1-3.4-1s-1.3-2.2-1-3.4l2.2-11.2c.4-2.2,1.5-4.2,3.1-5.8,0,0,21-21,21-21ZM73.85,43.53c-1.5-1.5-3.9-1.5-5.4,0l-1.4,1.4,5.4,5.4,1.4-1.4c1.5-1.5,1.5-3.9,0-5.4ZM67.05,55.63l-5.4-5.4-14.2,14.2c-.5.5-.9,1.2-1,1.9l-1.1,5.6,5.6-1.1c.7-.1,1.4-.5,1.9-1,0,0,14.2-14.2,14.2-14.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeAgreement);
export default __webpack_public_path__ + "static/media/acae_agreement.d920ea11.svg";
export { ForwardRef as ReactComponent };